namespace StringUtility {
    export const clean = (str: string) => {
        if (str?.length) {
            return str;
        }

        return '';
    }

    export const uuid = (str: string) => {
        let value = clean(str);
        //this should ideally be done on the backend. To be removed once implemented from BE
        let regex = /(\w{8})(\w{4})(\w{4})(\w{4})(\w{12})/
        value = value.replace(regex, "$1-$2-$3-$4-$5")
        value = value.toLowerCase()
        return value;
    }

    const capitalize = (string = "") => {
        let res = ``;
        try {
            res = string?.charAt(0).toUpperCase() + string?.slice(1);
        } catch (error) {
            console.error("Error in capitalizeFirstLetter(). Error: ", error);
        }
        return res;
    }

    export const decodeCharFromHTMLEntity = (htmlChar: string) => {
        if (htmlChar && htmlChar?.length) {
            const tempElement = document.createElement('div');
            tempElement.innerHTML = htmlChar;
            const decodedChar = tempElement.textContent;
            tempElement.remove();
            return decodedChar;
        }

        return htmlChar;
    }

    export const formatFullName = (firstName: string, lastName: string) => {
        const name = capitalize(decodeCharFromHTMLEntity(firstName || ""));
        if(lastName?.length) {
            return `${name} ${decodeCharFromHTMLEntity(lastName).charAt(0).toUpperCase()}`
        }
        return name;
    };

    export const formatTeacherCount = (teacherCount: number | undefined): string => {
        if (teacherCount === undefined || teacherCount === null) {                                                             
            return "0";                                                                                                          
        }   
        switch(true){
            case(teacherCount >= 10000): return "10000+";
            case(teacherCount >= 5000): return "5000+";
            case(teacherCount >= 2000):return "2000+";
            case(teacherCount >= 1000): return "1000+";
            case (teacherCount >= 500): return "500+";
            case (teacherCount >= 100): return "100+";
            case (teacherCount >= 50): return "50+";
            default: return teacherCount.toString();
        }
    };

    export const gradeAbbrToFull = (grade: string): string => {
        const gradeMap: Record<string, string> = {
            'pk': 'pre-kindergarteners',
            'k': 'kindergarteners',
            '1': '1st graders',
            '2': '2nd graders',
            '3': '3rd graders',
            '4': '4th graders',
            '5': '5th graders',
        };
        return gradeMap[grade.toLowerCase()] || grade;
    };

    export const formatTeacherCountSchool = (teacherCount: number | undefined): string => {
        if (teacherCount === undefined || teacherCount === null) {
            return "0";
        }
        if (teacherCount > 100) return "100+";
        if (teacherCount >= 91) return "90+";
        if (teacherCount >= 81) return "80+";
        if (teacherCount >= 71) return "70+";
        if (teacherCount >= 61) return "60+";
        if (teacherCount >= 51) return "50+";
        if (teacherCount >= 41) return "40+";
        if (teacherCount >= 31) return "30+";
        if (teacherCount >= 21) return "20+";
        if (teacherCount >= 11) return "10+";
        if (teacherCount >= 6) return "6+";
        if (teacherCount >= 3) return "3+";
        return teacherCount.toString();
    };
}

export default StringUtility;